<script lang="ts" setup>
import heartIcon from '@consumer/assets/icons/heart.svg?svgicon'
</script>

<template>
  <GIcon :svg="heartIcon" size="20px" viewBox="0 -2 40 40"/>
</template>
